import Vue from 'vue';
import Router from 'vue-router';
import VueSocketio from 'vue-socket.io';
import _ from 'lodash';
import Segment from '@/Segment';
import { io } from 'socket.io-client';
import store from '@/store';
import LoginApi from '@/api/LoginApi';
import EmailRendering from '@/pages/responsive-pages/EmailRendering';
import SavingZone from '@/pages/responsive-pages/authenticated/navigation-pages/saving-zone/SavingZone';
import onbordingApi from '@/api/OnbordingApi';
import OnboardingState from '@/constants/onboarding-state';
import AuthenticateToken from '../pages/responsive-pages/authenticated/AuthenticateToken.vue';
import Complete2faLogin from '../pages/responsive-pages/single-factor-authenticated/2fa-login/Complete2faLoginScreen';
import Done2FAScreen from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faLoginDone.vue';
import TwoFactorMigration from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faMigration';
import ResetPassword from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faResetPassword';
import ResetPasswordDone from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faResetPasswordDone';
import InviteAuthenticateToken from '../pages/responsive-pages/invite-authenticated/InviteAuthenticateToken.vue';
import SingleFactorAuthenticateToken from '../pages/responsive-pages/single-factor-authenticated/SingleFactorAuthenticateToken.vue';
import SuspiciousGroupJoinInvestigator from '../pages/responsive-pages/authenticated/suspicious-group-join/SuspiciousGroupJoinInvestigator.vue';
import CredentialsSettings from '../pages/responsive-pages/authenticated/navigation-pages/credentials-settings/CredentialsSettings.vue';
import TransactionStories from '../pages/responsive-pages/authenticated/navigation-pages/transaction-stories/TransactionStories.vue';
import OnboardFlow from '../pages/responsive-pages/authenticated/onboard2/OnboardFlow.vue';
import CashflowApp from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/CashflowApp.vue';
import CashflowTourFlow from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-tour/CashflowTourFlow';
import DemoCashflowApp from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/DemoCashflowApp.vue';
import BalancePage from '../pages/responsive-pages/authenticated/navigation-pages/balance/BalancePage.vue';
import SignupFlow from '../pages/responsive-pages/non-authenticated/wine-and-dine/signup/SignupFlow.vue';
import LeadQualificationSurvey from '../pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/LeadQualificationFlow.vue';
import NPSSurveyFlow from '../pages/responsive-pages/authenticated/survey/NPS/NPSSurveyFlow.vue';
import ActivationSurvey from '../pages/responsive-pages/authenticated/survey/activation-survey/ActivationSurvey.vue';
import CSATSurvey from '../pages/responsive-pages/authenticated/survey/csat-survey/CSATSurvey.vue';
import Survey from '../pages/responsive-pages/authenticated/survey/Survey.vue';
import Playground from '../pages/base-ui-playground/Playground.vue';
import UnsupportedBanksMessagePage from '../pages/responsive-pages/authenticated/unsupported-banks/UnsupportedBanksMessagePage.vue';
import AppHeader from '../base-components/app-header/AppHeader.vue';
import ResponsivePage from '../pages/responsive-pages/ResponsivePage.vue';
import StateRouter from '../pages/responsive-pages/authenticated/routing/StateRouter.vue';
import DiscountLandingPage from '../pages/responsive-pages/non-authenticated/discount-api/DiscountLandingPage.vue';
import SubscriptionFlow from '../pages/responsive-pages/authenticated/subscription/SubscriptionFlow.vue';
import DiscountConnectionApprovedPage from '../pages/responsive-pages/non-authenticated/discount-api/DiscountConnectionApprovedPage.vue';
import PopupsManager from '../base-components/app-header/PopupsManager.vue';
import ChurnSurveyFlow from '../pages/responsive-pages/non-authenticated/churn/ChurnSurveyFlow.vue';
import AccountSettings from '../pages/responsive-pages/authenticated/navigation-pages/account-settings/AccountSettings.vue';
import LoginEnterPhoneNumber from '../pages/responsive-pages/non-authenticated/login/LoginEnterPhoneNumber.vue';
import LoginEnterCode from '../pages/responsive-pages/non-authenticated/login/LoginEnterCode.vue';
import LoginAs from '../pages/responsive-pages/non-authenticated/login/LoginAs.vue';
import config from '../config';
import WineAndDineFlow from '../pages/responsive-pages/non-authenticated/wine-and-dine/WineAndDineFlow.vue';
import FinishLQ from '../pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/FinishLQ.vue';
import UnsupportedBankGoodbye from '../base-components/onboarding/UnsupportedBankGoodbye.vue';
import InviteMember from '../pages/responsive-pages/authenticated/InviteMember.vue';
import OpenBankingLandingPage from '../pages/responsive-pages/non-authenticated/open-banking/OpenBankingLandingPage';
import CustomersApi from '../api/CustomersApi';
import MonthReviewFlowWrapper
  from '../pages/responsive-pages/authenticated/navigation-pages/month-review/MonthReviewFlowWrapper';
import Signup2faDoneScreen from '../pages/responsive-pages/single-factor-authenticated/2fa-login/Signup2faDoneScreen';

const { isNavigationFailure, NavigationFailureType } = Router;
const DISCOUNT_PROMO_CODE = 'discount';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
      throw err;
    }
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
      throw err;
    }
  });
};

Vue.use(Router);

async function initCustomerState(to) {
  await Promise.all([
    store.dispatch('loader/startLoading', 'customerState'),
    store.dispatch('session/init', {
      incognito: to.query.incognito,
      name: to.name,
    }),
    store.dispatch('sourceFields/initSourceFields'),
    store.dispatch('discountPromotion/initDiscountPromotion'),
    store.dispatch('onboardingState/fetchOnboardingState'),
    store.dispatch('customerState/init'),
    store.dispatch('benefits/initBenefits'),
    store.dispatch('subscriptionState/initSubscriptionState'),
    store.dispatch('onthemapChallenge/initOnTheMapChallenge'),
    store.dispatch('tour/init'),
    store.dispatch('savings/initSavings'),
    store.dispatch('cashflowView/setSplitTransactionEnabled'),
  ]);
  await store.dispatch('loader/doneLoading', 'customerState');
}

function initWebSockets() {
  if (!Vue.prototype.$socket) {
    Vue.use(new VueSocketio({
      debug: false,
      connection: io(config.get().elsaPublicUrl, {
        path: '/websockets',
        transports: ['websocket', 'polling'],
        reconnectionAttempts: 3,
        autoConnect: false,
      }),
      vuex: {
        store,
        mutationPrefix: 'socket_',
      },
    }));
  }
  if (!Vue.prototype.$socket.connected) {
    Segment.trackUserGot('TempSocketConnect');
    Vue.prototype.$socket.connect();
  }
}

async function redirectToLogin(to, next) {
  const redirectTo = _.trimStart(to.path, '/');
  const isPartiallyLoggedIn = await LoginApi.isPartialLoggedIn();
  if (isPartiallyLoggedIn) {
    if ((await CustomersApi.getPartiallyAuthenticatedMember()).hasOidc) {
      Segment.trackUserGot('2faRedirectToAuth0Login');
      window.location.href = `/api/partial-auth/login-with-auth0/${redirectTo}`;
      return;
    }
    if ((await onbordingApi.fetchOnboardingState()).onboardingState !== OnboardingState.ONBOARDING_PAGE.CASHFLOW) {
      Segment.trackUserGot('2faRedirectToAuth0SignupInOnboarding');
      window.location.href = '/api/partial-auth/login-with-auth0/new';
      return;
    }
  }
  const redirectPath = isPartiallyLoggedIn ? '/2fa-migration' : '/login';
  const query = { redirectTo, ...to.query };
  next({ path: redirectPath, query });
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/internal/playground',
      name: 'Playground',
      component: Playground,
    },
    {
      path: '/',
      name: 'ResponsivePage',
      component: ResponsivePage,
      children: [
        {
          path: '/signup',
          name: 'WineAndDineFlow',
          component: WineAndDineFlow,
          async beforeEnter(to, from, next) {
            // convert discount utm to promo code
            if (to.query.utm_source === 'Discount_app' && !to.query.promoCode) {
              const query = { promoCode: DISCOUNT_PROMO_CODE, ...to.query };
              next({ path: to.path, query });
            } else {
              next();
            }
          },
          props: route => {
            const props = {};
            if (route.query.refToken) {
              props.referralData = { householdName: route.query.hn, referralToken: route.query.refToken };
            }
            if (route.query.promoCode) {
              props.promoCode = route.query.promoCode;
            }
            return props;
          },
        },
        {
          path: '/signup/lq/vp/:componentName',
          name: 'LeadQualificationSurvey',
          component: LeadQualificationSurvey,
          props: route => {
            return { componentName: route.params.componentName, componentType: 'valueProp' };
          },
        },
        {
          path: '/signup/lq/finish',
          name: 'FinishLQ',
          component: FinishLQ,
        },
        {
          path: '/signup/lq/question/:componentName',
          name: 'LeadQualificationSurvey',
          component: LeadQualificationSurvey,
          props: route => {
            return { componentName: route.params.componentName, componentType: 'question' };
          },
        },
        {
          path: '/demo/',
          name: 'Demo',
          component: DemoCashflowApp,
        },
        {
          path: '/email-rendering',
          name: 'EmailRendering',
          component: EmailRendering,
        },
        {
          path: '/signup/details',
          name: 'Signup',
          component: SignupFlow,
          props: route => {
            return { promoCode: route.query.promoCode };
          },
        },
        {
          path: '/goodbye',
          name: 'GoodbyePage',
          component: ChurnSurveyFlow,
        },
        {
          path: '/internal/login-as',
          name: 'LoginAs',
          component: LoginAs,
        },
        {
          path: '/login',
          name: 'Login',
          component: LoginEnterPhoneNumber,
        },
        {
          path: '/login-enter-code',
          name: 'LoginEnterCode',
          component: LoginEnterCode,
        },
        {
          path: '/invite',
          name: 'MemberInvite',
          component: InviteAuthenticateToken,
        },
        {
          path: '/',
          name: 'SingleFactorAuthenticateToken',
          component: SingleFactorAuthenticateToken,
          redirect: { name: 'StateRouter' },
          async beforeEnter(to, from, next) {
            if (await LoginApi.isPartialLoggedIn()) {
              next();
            } else {
              const query = { redirectTo: _.trimStart(to.path, '/'), ...to.query };
              next({ path: 'login', query });
            }
          },
          children: [
            {
              path: '/complete-2fa-login',
              name: '2faLoginComplete',
              component: Complete2faLogin,
            },
            {
              path: '/add-2fa-done',
              name: '2faLoginDone',
              component: Done2FAScreen,
            },
            {
              path: '/2fa-migration',
              name: '2faMigration',
              component: TwoFactorMigration,
            },
            {
              path: '/signup-2fa-done',
              name: '2faSignupDone',
              component: Signup2faDoneScreen,
            },
            {
              path: '/2fa-Reset-Password',
              name: 'TwofaResetPassword',
              component: ResetPassword,
            },
            {
              path: '/2fa-Reset-Password-Done',
              name: 'TwofaResetPasswordDone',
              component: ResetPasswordDone,
            },
          ],
        },
        {
          path: '/',
          name: 'AuthenticateToken',
          component: AuthenticateToken,
          redirect: { name: 'StateRouter' },
          async beforeEnter(to, from, next) {
            if (await LoginApi.isLoggedIn()) {
              await initCustomerState(to);
              initWebSockets();
              next();
            } else {
              await redirectToLogin(to, next);
            }
          },
          children: [
            {
              path: '/',
              name: 'AppHeader',
              component: AppHeader,
              children: [
                {
                  path: '/',
                  name: 'PopupsManager',
                  component: PopupsManager,
                  props: route => {
                    return { hideCta: Boolean(route.query.hideCta) };
                  },
                  children: [
                    {
                      path: 'home',
                      name: 'Home',
                      component: CashflowApp,
                    }, {
                      path: 'cashflow-app',
                      name: 'CashflowApp',
                      component: CashflowApp,
                    }, {
                      path: 'balance',
                      name: 'BalancePage',
                      component: BalancePage,
                    }, {
                      path: 'credentials',
                      name: 'CredentialsSettings',
                      component: CredentialsSettings,
                    }, {
                      path: 'stories',
                      name: 'TransactionStories',
                      component: TransactionStories,
                    }, {
                      path: 'account-settings',
                      name: 'AccountSettings',
                      component: AccountSettings,
                    }, {
                      path: 'saving-zone',
                      name: 'SavingZone',
                      component: SavingZone,
                    }, {
                      path: '/s/token',
                      name: 'DiscountConnectionApprovedPage',
                      component: DiscountConnectionApprovedPage,
                    },
                  ],
                }, {
                  path: 'tour',
                  name: 'Tour',
                  component: CashflowTourFlow,
                }, {
                  path: 'mr',
                  name: 'MonthReview',
                  component: MonthReviewFlowWrapper,
                },
              ],
            },
            {
              path: 'telecom-story',
              name: 'TelecomStory',
              async beforeEnter(to, from, next) {
                Segment.trackUserInteraction('TelecomStoryExpiredEntered');
                next({ path: '/sr' });
              },
            },
            {
              path: 'sr',
              name: 'StateRouter',
              component: StateRouter,
            }, {
              path: 'group-join', // in app
              name: 'SuspiciousGroupJoinInvestigator',
              component: SuspiciousGroupJoinInvestigator,
            }, {
              path: '/invite-member',
              name: 'InviteMember',
              component: InviteMember,
            }, {
              path: 'unsupported-banks', // in app
              name: 'UnsupportedBanks',
              component: UnsupportedBanksMessagePage,
            }, {
              path: 'unsupported-bank', // in app
              name: 'UnsupportedBank',
              component: UnsupportedBankGoodbye,
              props: route => {
                return { sourceName: route.query.sourceName, sourceDisplayName: route.query.sourceDisplayName };
              },
            }, {
              path: 'subscription', // out of app
              name: 'subscription',
              component: SubscriptionFlow,
            },
            {
              path: 'survey',
              name: 'Survey',
              component: Survey,
              children: [
                {
                  path: 'first-cashflow', // in app
                  name: 'First Cashflow Survey',
                  component: ActivationSurvey,
                },
                {
                  path: 'csat', // in app
                  name: 'CSAT Survey',
                  component: CSATSurvey,
                },
                {
                  path: 'nps',
                  name: 'NPS survey',
                  component: NPSSurveyFlow,
                },
              ],
            },
            {
              path: '/ob',
              name: 'Onboard',
              component: OnboardFlow,
            },
            {
              path: '/discount/welcome-back',
              name: 'DiscountLandingPage',
              component: DiscountLandingPage,
            },
            {
              path: '/:source/welcome-back',
              name: 'OpenBankingLandingPage',
              component: OpenBankingLandingPage,
            },
            {
              path: '*',
              redirect: { name: 'AuthenticateToken' },
            },
          ],
        },
      ],
    },
  ],
});
